import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { getDisabledSourceNames, getBaseSources, getBaseSourcesLoading } from '../../selectors';
import { SourceSchema } from '../../types';
import DimensionItemsCell from './DimensionItemsCell';

const SourcesCell = ({ key, baseSources, selectedSourceNames, operator, disabledSourceNames, ...props }) => {
    const dimensionSources = baseSources.filter(source => selectedSourceNames.some(name => source.name === name));

    return (
        <DimensionItemsCell
            key={key}
            allItems={baseSources.filter(source => !disabledSourceNames.includes(source.name))}
            dimensionItems={dimensionSources}
            itemType="SOURCES"
            operator={operator}
            {...props}
        />
    );
};

SourcesCell.propTypes = {
    key: PropTypes.string.isRequired,
    baseSources: PropTypes.arrayOf(SourceSchema).isRequired,
    selectedSourceNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    disabledSourceNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    operator: PropTypes.string.isRequired,
};

export default connect((state, { isLoading }) => ({
    baseSources: getBaseSources(state),
    disabledSourceNames: getDisabledSourceNames(state),
    isLoading: isLoading || getBaseSourcesLoading(state),
}))(SourcesCell);
